import * as React from "react";
import styled from "@mui/material/styles/styled";

import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { IconButton } from "@mui/material";

//region [[ Styles ]]

const BackButtonView = styled(IconButton)(({ theme }) => ({}));

const BackIcon = styled(KeyboardArrowLeftIcon)(
  ({ iconColor }: { iconColor: string }) => ({
    color: iconColor ? iconColor : RosebudColorMap.button,
    marginTop: "4px",
    fontSize: "xx-large",
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface BackButtonProps {
  className?: string;
  color?: string;
  onClick?: (event) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const BackButton = ({ ...props }: BackButtonProps) => {
  return (
    <BackButtonView
      className={props.className}
      onClick={props.onClick ? props.onClick : null}
    >
      <BackIcon iconColor={props.color} />
    </BackButtonView>
  );
};
